






































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import Tools from '../../../../../lib/tools';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'infomationNet',
	components: {
		QuickTable
	}
})
export default class InfomationNet extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		personData: [],
		organizations: [],			// 部门数据
		formData: {
			id: '',
			useDepId: '',
			useUserId: '',
			facilityType: '',
			secretInvolvementType: '',
			buyDt: '',
			fixedAssetNumber: '',
			hardDiskSerialNumberOrModel: '',
			netType: '',
			macAddress: '',
			ipAddress: '',
			commitment: '',
			rectificationInfo: ''
		},
		validate: {
			facilityType: [
				{ required: true, message: '请填写设备类型', trigger: 'blur' }
			],
			secretInvolvementType: [
				{ required: true, message: '请填写涉密类型', trigger: 'blur' }
			],
			useDepId: [
				{ required: true, type: 'number', message: '请选择使用部门', trigger: 'change' }
			],
			useUserId: [
				{ required: true, type: 'number', message: '请选择使用人', trigger: 'change' }
			]
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '使用部门',
				key: 'useDep',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', params.row.useDep ? params.row.useDep.displayName : '');
				}
			},
			{
				title: '使用人',
				key: 'useUser',
				width: 146,
				render: (h:any, params:any) => {
					return h('span', params.row.useUser ? params.row.useUser.name : '');
				}
			},
			{
				title: '设备类型',
				key: 'facilityType',
				minWidth: 140
			},
			{
				title: '涉密类型',
				key: 'secretInvolvementType',
				minWidth: 140
			},
			{
				title: '购买日期',
				key: 'buyDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.buyDt));
				}
			},
			{
				title: '固定资产编号',
				key: 'fixedAssetNumber',
				minWidth: 168
			},
			{
				title: '硬盘序列号/设备规格型号',
				key: 'hardDiskSerialNumberOrModel',
				minWidth: 180
			},
			{
				title: '所属网型',
				key: 'netType',
				width: 136
			},
			{
				title: '设备MAC地址',
				key: 'macAddress',
				width: 148
			},
			{
				title: '现使用IP地址',
				key: 'ipAddress',
				width: 136
			},
			{
				title: '涉密人员上岗保密承诺书',
				key: 'commitment',
				minWidth: 180
			},
			{
				title: '整改情况',
				key: 'rectificationInfo',
				minWidth: 160
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = params.row[k];
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personData = this.$store.state.project.allPersons;
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'buyDt') {
							params[k] = Tools.formatDate(datas[k]);
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/SafetyProduct/UpdateInfomationNetAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyProduct/CreateInfomationNetAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此信息网络管理台账？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteInfomationNetAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
